<style lang="scss" src='./AlertList.scss' scoped ></style>
<template src="./AlertList.html"></template>

<script>
import AlertItem from "../item/AlertItem.vue";
import VuePullRefresh from "vue-pull-refresh";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import CommonComponent from "@/components/utils/CommonComponent.vue";
import RefreshButton from '@/components/refreshButton/RefreshButton.vue';
import { isEmpty } from 'lodash';

export default {
  name: "AlertList",
  extends: CommonComponent,
  components: {
    "vue-pull-refresh": VuePullRefresh,
    AlertItem,
    RefreshButton
  },
  data() {
    return {
      alertSelected: {},
      maxHeightAlert: 600,
      alertUpdateInterval: null,
      alertTypeArray: [],
    };
  },
  computed: {
    ...mapState("AlertList", {
      alerts: (state) => state.alerts,
      alertStatusFilter: (state) => state.alertStatusFilter,
      loading: (state) => state.loading,
    }),
    ...mapGetters("AlertList", ["alertsFiltered"]),
  },
  watch: {
    course() {
      this.loadData();
    },
  },
  methods: {
    refreshAlertList() {
      const self = this;
      // eslint-disable-next-line
      return new Promise(async function (resolve, reject) {
        await self.loadAlerts();
        resolve("ok");
      });
    },

    startIntervalToRefreshAlerts() {
      this.alertUpdateInterval = window.setInterval(
        this.redo,
        process.env.VUE_APP_REFRESH_DATA_TIME_MS
      );
    },

    redo(){
      // Pass true to hide loading
      this.loadAlerts(true)
    },

    loadData() {
      const selectArray = [
        this.consts.AlertType.DIELECTRIC,
        this.consts.AlertType.GROUND_TEMPERATURE,
        this.consts.AlertType.MOISTURE,
        this.consts.AlertType.SALINITY,
        this.consts.AlertType.LOW_RSSI,
        this.consts.AlertType.AIR_TEMPERATURE,
        this.consts.AlertType.BAROMETRIC_PRESSURE,
        this.consts.AlertType.ET_RATE,
        this.consts.AlertType.HORIZONTAL_WIND_SPEED,
        this.consts.AlertType.LIGHTNING_STRIKE,
        this.consts.AlertType.PRECIPITATION,
        this.consts.AlertType.RELATIVE_HUMIDITY,
        this.consts.AlertType.WIND_GUST
      ];

      if(this.isAdminOrOpsUser()){
        selectArray.push(this.consts.AlertType.COMMUNICATION_FAILURE);
        selectArray.push(this.consts.AlertType.SENSOR_TRANSITION);
        selectArray.push(this.consts.AlertType.WS_COMMUNICATION_FAILURE);
      }

      this.alertTypeArray = [...selectArray];

      this.loadAlerts();
    },

    isAdminOrOpsUser(){
      if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
            this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
          return true;
      }
      return false;
    },

    async selectAlert(alert) {
      if (alert) {
        this.alertSelected = alert;
        this.$store.commit("setAlert", alert);
        this.$router.push('/alerts-details');
      }
    },

    adjustAlertListHeight() {
      const self = this;
      // eslint-disable-next-line
      const alertHeightInterval = setInterval(function () {
        if (self.$refs.alertsContainer) {
          self.maxHeightAlert =
            window.innerHeight -
            60 -
            self.$refs.alertsContainer.getBoundingClientRect().top;
        }
      }, 0);
      // eslint-disable-next-line
      setTimeout(function () {
        clearInterval(alertHeightInterval);
      }, 5000);
    },

    ...mapActions("AlertList", ["loadAlerts"]),

    ...mapMutations("AlertList", [
      "setLoading",
      "setAlertStatusFilter",
      "setAlerts",
    ]),
  },

  beforeCreate() {},

  created() {},
  
  beforeMount() {
    this.setShowMenu(true);
    this.setShowBackground(true);
  },

  mounted() {
    this.adjustAlertListHeight();
    this.loadData();
    this.startIntervalToRefreshAlerts();

    if(!isEmpty(this.$route.params)){
      this.setAlertStatusFilter(this.$route.params.type);
    }
  },

  beforeDestroy() {
    window.clearInterval(this.alertUpdateInterval);
  },
};
</script>
